
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle, Home, RefreshCw } from "lucide-react";
import ErrorDisplay from "@/components/ErrorDisplay";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const isDnsError = 
    window.location.hostname !== 'localhost' && 
    window.location.hostname !== '127.0.0.1' &&
    !window.location.hostname.includes('lovable.app');

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-slate-900 p-4">
      <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="h-20 w-20 rounded-full bg-destructive/10 dark:bg-destructive/20 flex items-center justify-center">
            <AlertCircle className="h-10 w-10 text-destructive dark:text-destructive" />
          </div>
        </div>

        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">404</h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 mb-4">Oops! Page not found</p>
        
        {isDnsError ? (
          <div className="mb-6">
            <p className="text-amber-600 dark:text-amber-400 font-medium mb-2">
              This appears to be a DNS configuration issue
            </p>
            <div className="bg-amber-50 dark:bg-amber-900/20 p-4 rounded-md text-left mb-4">
              <ul className="list-disc list-inside space-y-2 text-sm text-gray-600 dark:text-gray-300">
                <li>Verify your DNS records are properly configured</li>
                <li>Check for typos in your domain name</li>
                <li>Allow 24-48 hours for DNS changes to fully propagate</li>
                <li>Ensure your custom domain is properly linked in your project settings</li>
              </ul>
            </div>
          </div>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
            The requested URL <code className="bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded">{location.pathname}</code> was not found on this server.
          </p>
        )}
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild variant="default">
            <Link to="/" className="flex items-center gap-2">
              <Home className="h-4 w-4" />
              Home
            </Link>
          </Button>
          <Button variant="outline" onClick={handleRefresh} className="flex items-center gap-2">
            <RefreshCw className="h-4 w-4" />
            Refresh
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
